module.exports = __webpack_public_path__ + "files/5420aa17c2d4e734e2483c128d37c5f4.png";


/*****************
 ** WEBPACK FOOTER
 ** ./images/themes/mattermost.png
 ** module id = 824
 ** module chunks = 0
 **/